/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { State, Step, UploadCubeInfo } from './data-contracts'
import { HttpClient, RequestParams } from './http-client'

export class JobClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Job
   * @summary Получить список недогруженных файлов по проекту
   * @request GET:/seismicImport/api/v1/Job/activeImportJobs/{projectId}
   * @secure
   */
  jobGetNotCompletedImportJobs = (projectId: string, params: RequestParams = {}) =>
    this.http.request<UploadCubeInfo[], any>({
      path: `/seismicImport/api/v1/Job/activeImportJobs/${projectId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Job
   * @summary Обновление состояния задачи импорта
   * @request PUT:/seismicImport/api/v1/Job/updateJob
   * @secure
   */
  jobUpdateJobState = (
    query: {
      /**
       * Идентификатор объекта
       * @format uuid
       */
      entityId: string
      /** этап импорта */
      step: Step
      /** статус этапа */
      state: State
      /** инф. сообщение */
      message?: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/seismicImport/api/v1/Job/updateJob`,
      method: 'PUT',
      query: query,
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags Job
   * @summary Обновление состояния задачи импорта
   * @request PUT:/seismicImport/api/v1/Job/completeJob
   * @secure
   */
  jobCompleteJob = (
    query: {
      /**
       * Идентификатор объекта
       * @format uuid
       */
      entityId: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/seismicImport/api/v1/Job/completeJob`,
      method: 'PUT',
      query: query,
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags Job
   * @summary Удалить задачу импорта
   * @request DELETE:/seismicImport/api/v1/Job
   * @secure
   */
  jobRemoveJob = (
    query: {
      /**
       * Идентификатор объекта в задаче
       * @format uuid
       */
      entityId: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/seismicImport/api/v1/Job`,
      method: 'DELETE',
      query: query,
      secure: true,
      ...params,
    })
}
